import axios from 'axios';
import qs from 'qs';

export default {
  namespace: true,
  state: {
    email_templates: [],
    email_templates_total: 0,
    used_email_template_types: [],
    loading: false,
    loading_total: false,
    loading_type: false,
    query: ''
  },
  getters: {
    email_templates: state => state.email_templates,
    email_templates_total: state => state.email_templates_total,
    used_email_template_types: state => state.used_email_template_types,
    loading: state => state.loading,
    loading_total: state => state.loading_total,
    loading_type: state => state.loading_type,
    query: state => state.query
  },
  mutations: {
    CLEAR_EMAIL_TEMPLATES(state) {
      state.email_templates = [];
    },
    CLEAR_EMAIL_TEMPLATES_TOTAL(state) {
      state.email_templates_total = 0;
    },
    CLEAR_USED_EMAIL_TEMPLATE_TYPES(state) {
      state.used_email_template_types = [];
    },
    CLEAR_QUERY(state) {
      state.query = '';
    },
    SET_LOADING_EMAIL_TEMPLATE(state, loading) {
      state.loading = loading;
    },
    ADD_EMAIL_TEMPLATE_TO_LIST(state, email_template) {
      state.email_templates.push(email_template);
    },
    SET_LOADING_EMAIL_TEMPLATES_TOTAL(state, loading_total) {
      state.loading_total = loading_total;
    },
    SET_EMAIL_TEMPLATES_TOTAL(state, email_templates_total) {
      state.email_templates_total = email_templates_total;
    },
    SET_LOADING_USED_EMAIL_TEMPLATE_TYPE(state, loading_type) {
      state.loading_type = loading_type;
    },
    ADD_USED_EMAIL_TEMPLATE_TYPE_TO_LIST(state, used_email_template_type) {
      state.used_email_template_types.push(used_email_template_type)
    },
    SET_QUERY(state, query) {
      state.query = query;
    }
  },
  actions: {
    LOAD_EMAIL_TEMPLATES({ commit, state, rootState }, pagination_options) {
      commit('SET_LOADING_EMAIL_TEMPLATE', false);
      const { token, clientid } = rootState;
      const { query } = state;
      const { sortBy, sortDesc, page, itemsPerPage } = pagination_options;
      const sort_by  = sortBy.length   ? sortBy[0]   : 'created_at';
      const sort_dir = sortDesc.length ? sortDir[0] : 'desc';
      const offset   = (page - 1) * itemsPerPage;
      const limit    = itemsPerPage;
      const q = qs.stringify({ token, clientid, query, sort_by, sort_dir, offset, limit });
      const url = `${process.env.VUE_APP_API_URL}/get_all_email_template`;
      return axios.post(url, q)
      .then(({ data }) => {
        if (data) {
          commit('CLEAR_EMAIL_TEMPLATES');
          const { data: email_templates } = data;
          email_templates.forEach((email_template) => {
            commit('ADD_EMAIL_TEMPLATE_TO_LIST', email_template);
          });
        }
        commit('SET_LOADING_EMAIL_TEMPLATE', false);
      })
      .catch((err) => {
        commit('SET_LOADING_EMAIL_TEMPLATE', false);
      });
    },
    LOAD_EMAIL_TEMPLATES_TOTAL({ commit, state, rootState }) {
      commit('SET_LOADING_EMAIL_TEMPLATES_TOTAL', true);
      const { token, clientid } = rootState;
      const { query } = state;
      const q = qs.stringify({ token, clientid, query });
      const url = `${process.env.VUE_APP_API_URL}/get_email_template_total`;
      return axios.post(url, q)
      .then(({ data }) => {
        if (data) {
          commit('CLEAR_EMAIL_TEMPLATES_TOTAL');
          const { data: email_templates } = data;
          commit('SET_EMAIL_TEMPLATES_TOTAL', parseInt(email_templates.total));
        }
        commit('SET_LOADING_EMAIL_TEMPLATES_TOTAL', false);
      })
      .catch((err) => {
        commit('SET_LOADING_EMAIL_TEMPLATES_TOTAL', false);
      });
    },
    LOAD_USED_EMAIL_TEMPLATE_TYPES({ commit, state, rootState }) {
      const { token, clientid } = rootState;
      const q = qs.stringify({ token, clientid });
      const url = `${process.env.VUE_APP_API_URL}/get_email_template_types`;
      return axios.post(url, q)
      .then(({ data }) => {
        if (data) {
          commit('CLEAR_USED_EMAIL_TEMPLATE_TYPES')
          const { data: used_email_template_types } = data;
          used_email_template_types.forEach((used_email_template_type) => {
            commit('ADD_USED_EMAIL_TEMPLATE_TYPE_TO_LIST', used_email_template_type);
          });
        }
        commit('SET_LOADING_USED_EMAIL_TEMPLATE_TYPE', false);
      })
      .catch((err) => {
        commit('SET_LOADING_USED_EMAIL_TEMPLATE_TYPE', false);
      });
    },
    CREATE_EMAIL_TEMPLATE({ commit, rootState }, payload) {
      commit('SET_LOADING_EMAIL_TEMPLATE', true);
      const { token, clientid } = rootState;
      payload.clientid = clientid;
      const query = qs.stringify({ token, data: { ...payload } });
      const url = `${process.env.VUE_APP_API_URL}/create_email_template`;
      return axios.post(url, query)
        .then(() => {
          commit('SET_LOADING_EMAIL_TEMPLATE', false);
        })
        .catch((err) => {
          commit('SET_LOADING_EMAIL_TEMPLATE', false);
        });
    },
    UPDATE_EMAIL_TEMPLATE({ commit, rootState }, payload) {
      commit('SET_LOADING_EMAIL_TEMPLATE', true);
      const { token, clientid } = rootState;
      payload.clientid = clientid;
      const query = qs.stringify({ token, data: { ...payload } });
      const url = `${process.env.VUE_APP_API_URL}/update_email_template`;
      return axios.post(url, query)
        .then(() => {
          commit('SET_LOADING_EMAIL_TEMPLATE', false);
        })
        .catch((err) => {
          commit('SET_LOADING_EMAIL_TEMPLATE', false);
        });
    },
    DELETE_EMAIL_TEMPLATE({ commit, rootState }, id) {
      commit('SET_LOADING_EMAIL_TEMPLATE', true);
      const { token } = rootState;
      const query = qs.stringify({ token, id });
      const url = `${process.env.VUE_APP_API_URL}/delete_email_template`;
      return axios.post(url, query)
        .then(() => {
          commit('SET_LOADING_EMAIL_TEMPLATE', false);
        })
        .catch((err) => {
          commit('SET_LOADING_EMAIL_TEMPLATE', false);
        });
    },
  },
}
